import {
  ELanguage,
  IAddressFields,
  ITemplateResponse,
  TConvertKeys,
  TNullable,
} from './common';
import { IInstitutionContractServer, IPocSettingsServer } from './institutions';
import { IUserData } from './user';

export type TSymptomTriageProvider = 'infermedica' | 'isabel';
export type TSymptomTriage = 'manual' | TSymptomTriageProvider;

export enum EOrganizationProvisioningType {
  SEATS = 'seats',
  CONSULTS_PER_MONTH = 'consults_per_month',
}

export enum EOrganizationProvisioningScope {
  ORGANIZATION = 'organization',
  INSTITUTION = 'institution',
}

export interface IOrganizationPoc
  extends
    Partial<Omit<IAddressFields, 'city'>>,
    Pick<IPocSettingsServer, 'name' | 'title' | 'email'> {
  phone?: TNullable<IPocSettingsServer['phone']>;
}

export interface IOrganizationConfiguration {
  tfa?: boolean;
  symptom_triage?: boolean;
  triage_provider?: TSymptomTriageProvider;
  medical_station_calls?: boolean;
  canary_speech?: boolean;
  medwand?: boolean;
}

interface IOrganizationContract extends IInstitutionContractServer {
  consults_per_month?: number;
}

export interface IOrganizationProvisioning {
  type?: EOrganizationProvisioningType;
  scope?: EOrganizationProvisioningScope;
  contracts?: IOrganizationContract[];
}

export interface IOrganizationContractServer {
  id: string;
  seats?: TNullable<number>;
  station_licenses?: TNullable<number>;
  consults_per_month?: TNullable<number>;
  contract_start_date: string;
  contract_end_date: string;
}

export interface IOrganizationProvisioningServer extends Omit<
  IOrganizationProvisioning,
  'contracts'
> {
  seats?: TNullable<number>;
  occupied_seats?: TNullable<number>;
  contracts?: IOrganizationContractServer[];
}

export interface IOrganizationRequest extends Partial<IAddressFields> {
  name: string;
  language: ELanguage;
  poc_settings: IOrganizationPoc;
  configuration?: IOrganizationConfiguration;
  provisioning?: IOrganizationProvisioning;
}

export interface IOrganizationServer extends Partial<IAddressFields> {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  language?: ELanguage;
  poc_settings?: IOrganizationPoc;
  configuration?: TNullable<IOrganizationConfiguration>;
  provisioning?: IOrganizationProvisioningServer;
}

export type TOrganizationServerCamel = TConvertKeys<IOrganizationServer>;
export type TOrganizationRequestCamel = TConvertKeys<IOrganizationRequest>;
export type TOrganizationContractServerCamel =
  TConvertKeys<IOrganizationContractServer>;

export type IOrganizationResponse = ITemplateResponse<IOrganizationServer>;
export type IAllOrganizationsResponse = ITemplateResponse<
  IOrganizationServer[]
>;

export interface IOrganizationAdminInviteRequest {
  first_name: string;
  last_name: string;
  email: string;
}

export type TOrganizationAdminInviteRequestCamel =
  TConvertKeys<IOrganizationAdminInviteRequest>;

export type IOrganizationAdminsResponse = ITemplateResponse<IUserData[]>;
